module.exports = __webpack_public_path__ + "static/media/demo200Small.f507f87b.mp4";